import mainLogo from '../../images/BelcarYamaha/belcarYamaha_logo_main_color.png';
import squareLogo from '../../images/BelcarYamaha/belcarYamaha_square_color.png';
import squareLogoWhite from '../../images/BelcarYamaha/belcarYamaha_logo_main_white_color.png';
import squareLogoSmall from '../../images/BelcarYamaha/belcarYamaha_square_small_color.png';
import banner01 from '../../images/BelcarYamaha/belcarYamaha_banner_01_02.jpg';
import banner02 from '../../images/BelcarYamaha/belcarYamaha_banner_02_02.jpg';
import banner03 from '../../images/BelcarYamaha/belcarYamaha_banner_03.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'BelcarYamaha',
    defaultStoreLink: 'belcarmotospecas.com.br',
    launchDate: '15/05/2023',
    defaultContactEmail: 'mladmmotos@belcar.com.br',
    whatsappNumber: '62 98591 6039',
    CNPJname: 'BELCAR MOTOS LTDA',
    CNPJ: '06.008.462/0001-31',
    CNPJaddress: 'Avenida Independência, 5697, Quadra 68-A Lotes 15/19 - Setor Aeroporto, Goiânia/GO - 74.070-010',
    launchDate: '01/05/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'yamaha',
    ],

    homologBrands: [
        // 'motorcraft',
        // 'motrio',
        // 'acdelco',
        // 'mopar',
        // 'bproauto',
    ],

    noVehicle: true,

    storeSellersWarehouses: [
        "BELCAR MOTOS INDEPENDENCIA",
    ],

    disabledSellers: [],

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.YamahaKits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.YamahaOleos
        },
        // {
        //     name: 'Óleos',
        //     img: 'tabOleos',
        //     products: SliderProducts.Oleos
        // },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.YamahaFiltros
        },
        {
            name: 'Iluminação',
            img: 'tabLuzes',
            products: SliderProducts.YamahaLuzes
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.YamahaFreios
        },
        // {
        //     name: 'Acessórios',
        //     img: 'tabAcessorios',
        //     products: SliderProducts.Acessorios
        //     },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // }
    ],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    pixDiscount: 0.05,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            50: 2,
            200: 3,
            300: 4,
            500: 5,
            1200: 6,
        }
    },
    
    customShipping: {
        deliveryTime: 1,    
    }
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogoSmall,
    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerLogoWhite: squareLogoWhite,
    aboutUsBg: banner03,
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    car123: '',
    box123: '',

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto da concessionária <mark>Belcar Yamaha</mark>.',

    aboutUs: {
        title: 'Sobre nós',
        content: [
            'A Belcar Yamaha é especializada na venda de peças e acessórios originais Yamaha, oferecendo qualidade, confiança e um atendimento que vai além da entrega. Nosso foco é garantir a melhor experiência para os apaixonados por motos, com suporte completo durante e após a compra.',
            'Missão: Oferecer produtos Yamaha com procedência e excelência no atendimento, promovendo segurança e satisfação.',
            'Visão: Ser referência nacional em peças e acessórios Yamaha, com agilidade, confiança e relacionamento duradouro com nossos clientes.',
            'Valores: Comprometimento, transparência, excelência, respeito ao cliente e paixão por motos.',
            'Na Belcar Yamaha, o atendimento não termina na venda. Nosso pós-venda garante suporte técnico e atenção contínua para que você tenha sempre a melhor performance e confiança na estrada.',
        ],
        link: 'https://belcarmotos.com.br/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/belcaryamaha/',
        Facebook: 'https://www.facebook.com/BelcarYamaha/',
        LinkedIn: '',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}